/* unplugin-vue-components disabled */import script from "./dateShose.vue?vue&type=script&setup=true&lang=ts"
export * from "./dateShose.vue?vue&type=script&setup=true&lang=ts"

import "./dateShose.vue?vue&type=style&index=0&id=e85d9c0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e85d9c0e"]])

export default __exports__